/**
 * Student app information architecture (PRD §5.1, mirrors the design AppShell).
 * Routes are placeholders until each screen is built in its phase.
 */
export interface NavItem {
  readonly id: string;
  readonly label: string;
  readonly path: string;
  readonly badge?: number;
}

export interface NavGroup {
  readonly group: string;
  readonly items: readonly NavItem[];
}

export const NAV: readonly NavGroup[] = [
  {
    group: 'Today',
    items: [
      { id: 'home', label: 'Home', path: '/app' },
      { id: 'workout', label: 'Daily workout', path: '/app/workout' },
      { id: 'review', label: 'Review', path: '/app/review', badge: 12 },
    ],
  },
  {
    group: 'Practice',
    items: [
      { id: 'problem', label: 'Guided problem', path: '/app/problem' },
      { id: 'diagnostic', label: 'Diagnostic', path: '/app/diagnostic' },
    ],
  },
  {
    group: 'Drills',
    items: [
      { id: 'decon', label: 'Deconstructor', path: '/app/drill/deconstructor' },
      { id: 'sniff', label: 'Constraint sniffer', path: '/app/drill/constraint_sniffer' },
      { id: 'pattern', label: 'Pattern discriminator', path: '/app/drill/pattern_discriminator' },
      { id: 'visual', label: 'State visualizer', path: '/app/drill/state_visualizer' },
      { id: 'invariant', label: 'Invariant builder', path: '/app/drill/invariant_builder' },
      { id: 'counter', label: 'Counterexample', path: '/app/drill/counterexample' },
      { id: 'bridge', label: 'Implementation bridge', path: '/app/drill/implementation_bridge' },
      { id: 'bug', label: 'Bug trainer', path: '/app/drill/bug_trainer' },
    ],
  },
  {
    group: 'Progress',
    items: [
      { id: 'mastery', label: 'Mastery map', path: '/app/mastery' },
      { id: 'repair', label: 'Weakness repair', path: '/app/repair' },
      { id: 'library', label: 'Concept library', path: '/app/library' },
    ],
  },
  {
    group: 'Contest',
    items: [
      { id: 'contest', label: 'Contest sim', path: '/app/contest' },
      { id: 'postmortem', label: 'Postmortem', path: '/app/postmortem' },
    ],
  },
  {
    group: 'Classroom',
    items: [
      { id: 'assignments', label: 'Assignments', path: '/app/assignments' },
      { id: 'coach', label: 'Coach view', path: '/coach' },
    ],
  },
];
